import {CREATEJS_UTILITIES_LOGGER} from "../../../../../index";
import {getLogger} from "@goodgamestudios/logger";
import {ColorTransform} from "./ColorTransform";

const logger = getLogger(CREATEJS_UTILITIES_LOGGER + ".BitmapData");
//
const oldBitmapDataProto = createjs.BitmapData.prototype;
//const originalConstructor = createjs.BitmapData;
const originalConstructor = createjs.BitmapData.prototype.constructor;
const oldStatic =  createjs.BitmapData.getBitmapData;
(<any>createjs).BitmapData = function(width: number, height: number, transparent?: boolean, fillColor?: number | string) :any {
    if(typeof fillColor === "number")  {
        fillColor = ColorTransform.colorNumToString(fillColor);
    }
    originalConstructor.apply(this, [width, height, transparent, fillColor]);
};
createjs.BitmapData.prototype = oldBitmapDataProto;
createjs.BitmapData.getBitmapData =  oldStatic;

createjs.BitmapData.prototype.lock = function(): void {
    logger.debug("lock  not implemented yet");
}
createjs.BitmapData.prototype.unlock = function(): void {
    logger.debug("unlock  not implemented yet");
}
